import { call, put, takeEvery } from 'redux-saga/effects'
import {
  //getUser
  getUserData,
  getUserDataSuccess,
  getUserDataFailure,

  //getHospital
  getHospitalData,
  getHospitalDataSuccess,
  getHospitalDataFailure,

  //getDoctor
  getDoctorData,
  getDoctorDataSuccess,
  getDoctorDataFailure,

  //getCity
  getCityData,
  getCityDataSuccess,
  getCityDataFailed,

  // add City
  addCityData,
  addCityApiSuccess,
  addCityApiFailed,

  // update city
  updateCityData,
  updateCityApiSuccess,
  updateCityApiFailed,
  // delete City
  deleteCityData,
  deleteCityApiSuccess,
  deleteCityApiFailed,

  //getScanCategory
  getScanCategoryData,
  getScanCategoryDataSuccess,
  getScanCategoryDataFailed,

  //update User
  deleteUserData,
  deleteUserDataSuccess,
  deleteUserDataFailed,

  //addUser
  addUserData,
  addUserDataSuccess,
  addUserDataFailed,

  //updateDoctor
  updateDoctorData,
  updateDoctorDataSuccess,
  updateDoctorDataFailed,

  //addDoctor
  addDoctorData,
  addDoctorDataSuccess,
  addDoctorDataFailed,

  //deleteDoctor
  deleteDoctorDataSuccess,
  deleteDoctorDataFailed,
  deleteDoctorData,

  //deleteHospital
  deleteHospitalData,
  deleteHospitalDataSuccess,
  deleteHospitalDataFailed,

  //getImaBranch
  getImaBranchData,
  getImaBranchDataSuccess,
  getImaBranchDataFailed,

  //updateHospital
  updateHospitalData,
  updateHospitalDataSuccess,
  updateHospitalDataFailed,

  //addHospital
  addHospitalData,
  addHospitalDataSuccess,
  addHospitalDataFailed,

  //pharmacy
  //getPharmacy
  getPharmacyData,
  getPharmacyDataSuccess,
  getPharmacyDataFailed,

  //updatePharmacy
  updatePharmacyData,
  updatePharmacyDataSuccess,
  updatePharmacyDataFailed,

  //addPharmacy
  addPharmacyData,
  addPharmacyDataSuccess,
  addPharmacyDataFailed,

  //deletePharmacy
  deletePharmacyData,
  deletePharmacyDataSuccess,
  deletePharmacyDataFailed,

  //scan-center
  //getScanCenter
  getScanCenterData,
  getScanCenterDataSuccess,
  getScanCenterDataFailed,

  //updateScanCenter
  updateScanCenterData,
  updateScanCenterDataSuccess,
  updateScanCenterDataFailed,

  //addScanCenter
  addScanCenterData,
  addScanCenterDataSuccess,
  addScanCenterDataFailed,

  //deleteScanCenter
  deleteScanCenterData,
  deleteScanCenterDataSuccess,
  deleteScanCenterDataFailed,

  //laboratory
  //getLaboratory
  getLaboratoryData,
  getLaboratoryDataSuccess,
  getLaboratoryDataFailed,

  //updateLaboratory
  updateLaboratoryData,
  updateLaboratoryDataSuccess,
  updateLaboratoryDataFailed,

  //addLaboratory
  addLaboratoryData,
  addLaboratoryDataSuccess,
  addLaboratoryDataFailed,

  //deleteLaboratory
  deleteLaboratoryData,
  deleteLaboratoryDataSuccess,
  deleteLaboratoryDataFailed,

  //ambulance
  //getAmbulance
  getAmbulanceData,
  getAmbulanceDataSuccess,
  getAmbulanceDataFailed,

  //updateAmbulance
  updateAmbulanceData,
  updateAmbulanceDataSuccess,
  updateAmbulanceDataFailed,

  //addAmbulance
  addAmbulanceData,
  addAmbulanceDataSuccess,
  addAmbulanceDataFailed,

  //deleteAmbulance
  deleteAmbulanceData,
  deleteAmbulanceDataSuccess,
  deleteAmbulanceDataFailed,

  //Ambulance Type
  getAmbulanceTypeListData,
  getAmbulanceTypeListDataSuccess,
  getAmbulanceTypeListDataFailed,

  //Ambulance facilities
  getAmbulanceFacilitiesListData,
  getAmbulanceFacilitiesListDataSuccess,
  getAmbulanceFacilitiesListDataFailed,

  //Appointment Duration
  getAppointmentDurationListData,
  getAppointmentDurationListDataSuccess,
  getAppointmentDurationListDataFailed,

  //Appointment Status
  getAppointmentStatusList,
  getAppointmentStatusListSuccess,
  getAppointmentStatusListFailed,

  //Doctor Slot
  getDoctorSlotListSuccess,
  getDoctorSlotListFailed,
  getDoctorSlotList,

  //Booking
  //Get Booking
  getBookingList,
  getBookingListSuccess,
  getBookingListFailed,

  //Update Booking
  updateBookingList,
  updateBookingListSuccess,
  updateBookingListFailed,

  //Add Booking
  addBookingList,
  addBookingListSuccess,
  addBookingListFailed,

  //Delete Booking
  deleteBookingList,
  deleteBookingListSuccess,
  deleteBookingListFailed,

  //Booking Details
  getBookingDetailsData,
  getBookingDetailsDataSuccess,
  getBookingDetailsDataFailed,
  // Approved Pharmacy
  approvedPharmacyDataApiCall,
  approvedPharmacyDataSuccess,
  approvedPharmacyDataFailed,
} from './slice'
import { API } from '../../services'

//User
function* getUser({ type, payload }) {
  try {
    const response = yield call(API.providerManagementApi.userListApi, payload)
    if (response.data && response.status === 200) {
      yield put(getUserDataSuccess({ payload: response?.data }))
    } else {
      yield put(getUserDataFailure({ message: response.message }))
    }
  } catch (error) {
    yield put(getUserDataFailure({ message: error?.message }))
  }
}

//Hospital
function* getHospital({ type, payload }) {
  try {
    const response = yield call(API.providerManagementApi.hospitalListApi, payload)
    if (response.data && response.status === 200) {
      yield put(getHospitalDataSuccess({ payload: response?.data }))
    } else {
      yield put(getHospitalDataFailure({ message: response.message }))
    }
  } catch (error) {
    yield put(getHospitalDataFailure({ message: error?.message }))
  }
}

//Doctor
function* getDoctor({ type, payload }) {
  try {
    const response = yield call(API.providerManagementApi.doctorListApi, payload)
    if (response.data && response.status === 200) {
      yield put(getDoctorDataSuccess({ payload: response?.data }))
    } else {
      yield put(getDoctorDataFailure({ message: response.message }))
    }
  } catch (error) {
    yield put(getDoctorDataFailure({ message: error?.message }))
  }
}

//City
function* getCity({ type, payload }) {
  try {
    const response = yield call(API.providerManagementApi.cityListApi, payload)

    if (response.data && response.status === 200) {
      yield put(getCityDataSuccess({ payload: response?.data }))
    } else {
      yield put(getCityDataFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getCityDataFailed({ message: error?.message }))
  }
}
function* addCityApi({ type, payload }) {
  try {
    const response = yield call(API.providerManagementApi.addCity, payload)

    if (response.data && response.status === 200) {
      yield put(addCityApiSuccess({ payload: response?.data }))
    } else {
      yield put(addCityApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(addCityApiFailed({ message: error?.message }))
  }
}
function* updateCityApi({ type, payload }) {
  try {
    const response = yield call(API.providerManagementApi.updateCity, payload)

    if (response.data && response.status === 200) {
      yield put(updateCityApiSuccess({ payload: response?.data }))
    } else {
      yield put(updateCityApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(updateCityApiFailed({ message: error?.message }))
  }
}
function* deleteCityApi({ type, payload }) {
  try {
    const response = yield call(API.providerManagementApi.deleteCity, payload)

    if (response.data && response.status === 200) {
      yield put(deleteCityApiSuccess({ payload: response?.data }))
    } else {
      yield put(deleteCityApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(deleteCityApiFailed({ message: error?.message }))
  }
}

//Scan Category
function* getScanCategory({ type, payload }) {
  try {
    const response = yield call(API.providerManagementApi.scanCategoryListApi, payload)

    if (response.data && response.status === 200) {
      yield put(getScanCategoryDataSuccess({ payload: response?.data }))
    } else {
      yield put(getScanCategoryDataFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getScanCategoryDataFailed({ message: error?.message }))
  }
}

function* deleteUser({ type, payload }) {
  try {
    const response = yield call(API.providerManagementApi.deleteUserData, payload)
    if (response.data && response.status === 200) {
      yield put(deleteUserDataSuccess({ payload: response?.data }))
    } else {
      yield put(deleteUserDataFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(deleteUserDataFailed({ message: error?.message }))
  }
}

function* addUser({ type, payload }) {
  try {
    const response = yield call(API.providerManagementApi.addUserData, payload)
    if (response.data && response.status === 200) {
      yield put(addUserDataSuccess({ payload: response?.data }))
    } else {
      yield put(addUserDataFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(addUserDataFailed({ message: error?.message }))
  }
}

function* updateDoctor({ type, payload }) {
  try {
    const response = yield call(API.providerManagementApi.updateDoctorData, payload)
    if (response.data && response.status === 200) {
      yield put(updateDoctorDataSuccess({ payload: response?.data }))
    } else {
      yield put(updateDoctorDataFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(updateDoctorDataFailed({ message: error?.message }))
  }
}

function* updateHospital({ type, payload }) {
  try {
    const response = yield call(API.providerManagementApi.updateHospitalData, payload)
    if (response.data && response.status === 200) {
      yield put(updateHospitalDataSuccess({ payload: response?.data }))
    } else {
      yield put(updateHospitalDataFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(updateHospitalDataFailed({ message: error?.message }))
  }
}

function* addDoctor({ type, payload }) {
  try {
    const response = yield call(API.providerManagementApi.addDoctorData, payload)
    if (response.data && response.status === 200) {
      yield put(addDoctorDataSuccess({ payload: response?.data }))
    } else {
      yield put(addDoctorDataFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(addDoctorDataFailed({ message: error?.message }))
  }
}

function* getImaBranch({ type, payload }) {
  try {
    const response = yield call(API.providerManagementApi.getImaBranchData, payload)
    if (response.data && response.status === 200) {
      yield put(getImaBranchDataSuccess({ payload: response?.data }))
    } else {
      yield put(getImaBranchDataFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getImaBranchDataFailed({ message: error?.message }))
  }
}

// deleteDoctorData
function* deleteDoctor({ type, payload }) {
  try {
    const response = yield call(API.providerManagementApi.deleteDoctorData, payload)
    if (response.data && response.status === 200) {
      yield put(deleteDoctorDataSuccess({ payload: response?.data }))
    } else {
      yield put(deleteDoctorDataFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(deleteDoctorDataFailed({ message: error?.message }))
  }
}

// deleteHospitalData
function* deleteHospital({ type, payload }) {
  try {
    const response = yield call(API.providerManagementApi.deleteHospitalData, payload)
    if (response.data && response.status === 200) {
      yield put(deleteHospitalDataSuccess({ payload: response?.data }))
    } else {
      yield put(deleteHospitalDataFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(deleteHospitalDataFailed({ message: error?.message }))
  }
}

//addHospital
function* addHospital({ type, payload }) {
  try {
    const response = yield call(API.providerManagementApi.addHospitalData, payload)
    if (response.data && response.status === 200) {
      yield put(addHospitalDataSuccess({ payload: response?.data }))
    } else {
      yield put(addHospitalDataFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(addHospitalDataFailed({ message: error?.message }))
  }
}

//Pharmacy

//get pharmacy
function* getPharmacy({ type, payload }) {
  try {
    const response = yield call(API.providerManagementApi.getPharmacyData, payload)
    if (response.data && response.status === 200) {
      yield put(getPharmacyDataSuccess({ payload: response?.data }))
    } else {
      yield put(getPharmacyDataFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(getPharmacyDataFailed({ message: error?.message }))
  }
}

//delete pharmacy
function* deletePharmacy({ type, payload }) {
  try {
    const response = yield call(API.providerManagementApi.deletePharmacyData, payload)
    if (response.data && response.status === 200) {
      yield put(deletePharmacyDataSuccess({ payload: response?.data }))
    } else {
      yield put(deletePharmacyDataFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(deletePharmacyDataFailed({ message: error?.message }))
  }
}

//update pharmacy
function* updatePharmacy({ type, payload }) {
  try {
    const response = yield call(API.providerManagementApi.updatePharmacyData, payload)
    if (response.data && response.status === 200) {
      yield put(updatePharmacyDataSuccess({ payload: response?.data }))
    } else {
      yield put(updatePharmacyDataFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(updatePharmacyDataFailed({ message: error?.message }))
  }
}

//add pharmacy
function* addPharmacy({ type, payload }) {
  try {
    const response = yield call(API.providerManagementApi.addPharmacyData, payload)
    if (response.data && response.status === 200) {
      yield put(addPharmacyDataSuccess({ payload: response?.data }))
    } else {
      yield put(addPharmacyDataFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(addPharmacyDataFailed({ message: error?.message }))
  }
}

//ScanCenter

//get scan-center
function* getScanCenter({ type, payload }) {
  try {
    const response = yield call(API.providerManagementApi.getScanCenterData, payload)
    if (response.data && response.status === 200) {
      yield put(getScanCenterDataSuccess({ payload: response?.data }))
    } else {
      yield put(getScanCenterDataFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getScanCenterDataFailed({ message: error?.message }))
  }
}

//delete scan-center
function* deleteScanCenter({ type, payload }) {
  try {
    const response = yield call(API.providerManagementApi.deleteScanCenterData, payload)
    if (response.data && response.status === 200) {
      yield put(deleteScanCenterDataSuccess({ payload: response?.data }))
    } else {
      yield put(deleteScanCenterDataFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(deleteScanCenterDataFailed({ message: error?.message }))
  }
}

//update scan-center
function* updateScanCenter({ type, payload }) {
  try {
    const response = yield call(API.providerManagementApi.updateScanCenterData, payload)
    if (response.data && response.status === 200) {
      yield put(updateScanCenterDataSuccess({ payload: response?.data }))
    } else {
      yield put(updateScanCenterDataFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(updateScanCenterDataFailed({ message: error?.message }))
  }
}

//add scan-center
function* addScanCenter({ type, payload }) {
  try {
    const response = yield call(API.providerManagementApi.addScanCenterData, payload)
    if (response.data && response.status === 200) {
      yield put(addScanCenterDataSuccess({ payload: response?.data }))
    } else {
      yield put(addScanCenterDataFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(addScanCenterDataFailed({ message: error?.message }))
  }
}

//Laboratory

//get laboratory
function* getLaboratory({ type, payload }) {
  try {
    const response = yield call(API.providerManagementApi.getLaboratoryData, payload)
    if (response.data && response.status === 200) {
      yield put(getLaboratoryDataSuccess({ payload: response?.data }))
    } else {
      yield put(getLaboratoryDataFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getLaboratoryDataFailed({ message: error?.message }))
  }
}

//delete laboratory
function* deleteLaboratory({ type, payload }) {
  try {
    const response = yield call(API.providerManagementApi.deleteLaboratoryData, payload)
    if (response.data && response.status === 200) {
      yield put(deleteLaboratoryDataSuccess({ payload: response?.data }))
    } else {
      yield put(deleteLaboratoryDataFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(deleteLaboratoryDataFailed({ message: error?.message }))
  }
}

//update laboratory
function* updateLaboratory({ type, payload }) {
  try {
    const response = yield call(API.providerManagementApi.updateLaboratoryData, payload)
    if (response.data && response.status === 200) {
      yield put(updateLaboratoryDataSuccess({ payload: response?.data }))
    } else {
      yield put(updateLaboratoryDataFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(updateLaboratoryDataFailed({ message: error?.message }))
  }
}

//add laboratory
function* addLaboratory({ type, payload }) {
  try {
    const response = yield call(API.providerManagementApi.addLaboratoryData, payload)
    if (response.data && response.status === 200) {
      yield put(addLaboratoryDataSuccess({ payload: response?.data }))
    } else {
      yield put(addLaboratoryDataFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(addLaboratoryDataFailed({ message: error?.message }))
  }
}

//Ambulance

//get ambulance
function* getAmbulance({ type, payload }) {
  try {
    const response = yield call(API.providerManagementApi.getAmbulanceData, payload)
    if (response.data && response.status === 200) {
      yield put(getAmbulanceDataSuccess({ payload: response?.data }))
    } else {
      yield put(getAmbulanceDataFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getAmbulanceDataFailed({ message: error?.message }))
  }
}

//delete ambulance
function* deleteAmbulance({ type, payload }) {
  try {
    const response = yield call(API.providerManagementApi.deleteAmbulanceData, payload)
    if (response.data && response.status === 200) {
      yield put(deleteAmbulanceDataSuccess({ payload: response?.data }))
    } else {
      yield put(deleteAmbulanceDataFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(deleteAmbulanceDataFailed({ message: error?.message }))
  }
}

//update ambulance
function* updateAmbulance({ type, payload }) {
  try {
    const response = yield call(API.providerManagementApi.updateAmbulanceData, payload)
    if (response.data && response.status === 200) {
      yield put(updateAmbulanceDataSuccess({ payload: response?.data }))
    } else {
      yield put(updateAmbulanceDataFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(updateAmbulanceDataFailed({ message: error?.message }))
  }
}

//add ambulance
function* addAmbulance({ type, payload }) {
  try {
    const response = yield call(API.providerManagementApi.addAmbulanceData, payload)
    if (response.data && response.status === 200) {
      yield put(addAmbulanceDataSuccess({ payload: response?.data }))
    } else {
      yield put(addAmbulanceDataFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(addAmbulanceDataFailed({ message: error?.message }))
  }
}

//Ambulance type
function* getAmbulanceTypeList({ type, payload }) {
  try {
    const response = yield call(API.providerManagementApi.ambulanceTypeListApi, payload)

    if (response.data && response.status === 200) {
      yield put(getAmbulanceTypeListDataSuccess({ payload: response?.data }))
    } else {
      yield put(getAmbulanceTypeListDataFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getAmbulanceTypeListDataFailed({ message: error?.message }))
  }
}

//Ambulance facility
function* getAmbulanceFacilitiesList({ type, payload }) {
  try {
    const response = yield call(API.providerManagementApi.ambulanceFacilitiesListApi, payload)

    if (response.data && response.status === 200) {
      yield put(getAmbulanceFacilitiesListDataSuccess({ payload: response?.data }))
    } else {
      yield put(getAmbulanceFacilitiesListDataFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getAmbulanceFacilitiesListDataFailed({ message: error?.message }))
  }
}

//Appointment duration
function* getAppointmentDuration({ type, payload }) {
  try {
    const response = yield call(API.providerManagementApi.appointmentDurationListApi, payload)

    if (response.data && response.status === 200) {
      yield put(getAppointmentDurationListDataSuccess({ payload: response?.data }))
    } else {
      yield put(getAppointmentDurationListDataFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getAppointmentDurationListDataFailed({ message: error?.message }))
  }
}

//Appointment status
function* getAppointmentStatus({ type, payload }) {
  try {
    const response = yield call(API.providerManagementApi.appointmentStatusListApi, payload)

    if (response.data && response.status === 200) {
      yield put(getAppointmentStatusListSuccess({ payload: response?.data }))
    } else {
      yield put(getAppointmentStatusListFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getAppointmentStatusListFailed({ message: error?.message }))
  }
}

//Doctor slot
function* getDoctorSlot({ type, payload }) {
  try {
    const response = yield call(API.providerManagementApi.doctorSlotListApi, payload)

    if (response.data && response.status === 200) {
      yield put(getDoctorSlotListSuccess({ payload: response?.data }))
    } else {
      yield put(getDoctorSlotListFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getDoctorSlotListFailed({ message: error?.message }))
  }
}

//Booking

//get booking
function* getBooking({ type, payload }) {
  try {
    const response = yield call(API.providerManagementApi.getBookingList, payload)
    if (response.data && response.status === 200) {
      yield put(getBookingListSuccess({ payload: response?.data }))
    } else {
      yield put(getBookingListFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getBookingListFailed({ message: error?.message }))
  }
}

//delete booking
function* deleteBooking({ type, payload }) {
  try {
    const response = yield call(API.providerManagementApi.deleteBookingList, payload)
    if (response.data && response.status === 200) {
      yield put(deleteBookingListSuccess({ payload: response?.data }))
    } else {
      yield put(deleteBookingListFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(deleteBookingListFailed({ message: error?.message }))
  }
}

//update booking
function* updateBooking({ type, payload }) {
  try {
    const response = yield call(API.providerManagementApi.updateBookingList, payload)
    if (response.data && response.status === 200) {
      yield put(updateBookingListSuccess({ payload: response?.data }))
    } else {
      yield put(updateBookingListFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(updateBookingListFailed({ message: error?.message }))
  }
}

//add booking
function* addBooking({ type, payload }) {
  try {
    const response = yield call(API.providerManagementApi.addBookingList, payload)
    if (response.data && response.status === 200) {
      yield put(addBookingListSuccess({ payload: response?.data }))
    } else {
      yield put(addBookingListFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(addBookingListFailed({ message: error?.message }))
  }
}

//get Booking details
function* getBookingDetails({ type, payload }) {
  try {
    const response = yield call(API.providerManagementApi.getBookingDetails, payload)
    if (response.data && response.status === 200) {
      yield put(getBookingDetailsDataSuccess({ payload: response?.data }))
    } else {
      yield put(getBookingDetailsDataFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getBookingDetailsDataFailed({ message: error?.message }))
  }
}
function* approvedPharmacyDataApi({ type, payload }) {
  try {
    const response = yield call(API.providerManagementApi.approvedPharmacyData, payload)
    if (response.data && response.status === 200) {
      yield put(approvedPharmacyDataSuccess({ payload: response?.data }))
    } else {
      yield put(approvedPharmacyDataFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(approvedPharmacyDataFailed({ message: error?.message }))
  }
}

function* settingSaga() {
  //user
  yield takeEvery(getUserData, getUser)
  yield takeEvery(addUserData, addUser)
  yield takeEvery(deleteUserData, deleteUser)
  //doctor
  yield takeEvery(getDoctorData, getDoctor)
  yield takeEvery(updateDoctorData, updateDoctor)
  yield takeEvery(addDoctorData, addDoctor)
  yield takeEvery(deleteDoctorData, deleteDoctor)
  //ima
  yield takeEvery(getImaBranchData, getImaBranch)
  //city
  yield takeEvery(getCityData, getCity)
  yield takeEvery(addCityData, addCityApi)
  yield takeEvery(deleteCityData, deleteCityApi)
  yield takeEvery(updateCityData, updateCityApi)
  //scanCategory
  yield takeEvery(getScanCategoryData, getScanCategory)
  //hospital
  yield takeEvery(getHospitalData, getHospital)
  yield takeEvery(deleteHospitalData, deleteHospital)
  yield takeEvery(updateHospitalData, updateHospital)
  yield takeEvery(addHospitalData, addHospital)
  //pharmacy
  yield takeEvery(getPharmacyData, getPharmacy)
  yield takeEvery(deletePharmacyData, deletePharmacy)
  yield takeEvery(updatePharmacyData, updatePharmacy)
  yield takeEvery(addPharmacyData, addPharmacy)

  //scan-center
  yield takeEvery(getScanCenterData, getScanCenter)
  yield takeEvery(deleteScanCenterData, deleteScanCenter)
  yield takeEvery(updateScanCenterData, updateScanCenter)
  yield takeEvery(addScanCenterData, addScanCenter)
  //laboratory
  yield takeEvery(getLaboratoryData, getLaboratory)
  yield takeEvery(deleteLaboratoryData, deleteLaboratory)
  yield takeEvery(updateLaboratoryData, updateLaboratory)
  yield takeEvery(addLaboratoryData, addLaboratory)
  //ambulance
  yield takeEvery(getAmbulanceData, getAmbulance)
  yield takeEvery(deleteAmbulanceData, deleteAmbulance)
  yield takeEvery(updateAmbulanceData, updateAmbulance)
  yield takeEvery(addAmbulanceData, addAmbulance)
  //booking
  yield takeEvery(getBookingList, getBooking)
  yield takeEvery(deleteBookingList, deleteBooking)
  yield takeEvery(updateBookingList, updateBooking)
  yield takeEvery(addBookingList, addBooking)
  yield takeEvery(getBookingDetailsData, getBookingDetails)
  //ambulance type
  yield takeEvery(getAmbulanceTypeListData, getAmbulanceTypeList)
  //ambulance facilities
  yield takeEvery(getAmbulanceFacilitiesListData, getAmbulanceFacilitiesList)
  //appointment duration
  yield takeEvery(getAppointmentDurationListData, getAppointmentDuration)
  //appointment status
  yield takeEvery(getAppointmentStatusList, getAppointmentStatus)
  //doctor slot
  yield takeEvery(getDoctorSlotList, getDoctorSlot)
  // Approved Pharmacy
  yield takeEvery(approvedPharmacyDataApiCall, approvedPharmacyDataApi)
}

export default settingSaga
